import React from 'react';
import Grid from '@mui/material/Grid';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import DateTab from 'pages/date/Date';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';
import CommonSDF from 'components/commonSDF/CommonSdf';
import { Box } from '@mui/material';

function CustomerBreadCrumb(props) {

  const breadcrumbPaths = [
  ];

  return (
    <div>
        {/* <Grid item xs={5} md={3} border={"2px solid black"}>
          <CommonBreadCrumb paths={breadcrumbPaths} />
        </Grid> */}

          <Box sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-end', sm: 'flex-end' },
            alignItems: 'center',
            width: '100%',
          }}>
            <CommonSDF
              onSearch={props.onSearch}
              searchValue={props?.searchValue}
              defaultStatus={props.defaultStatus}
              filterdata={props?.filterdata}
              onFilterChange={props?.onFilterChange}
              onRestFilter={props?.onRestFilter}
            />
          </Box>
    </div>
  );
}

export default CustomerBreadCrumb;

